const CONST = {
    RESET: 'CODE_FORMATTER/RESET',
    UPDATE_STATE: 'CODE_FORMATTER/UPDATE_STATE',
    UPDATE_INPUT_CODE: 'CODE_FORMATTER/UPDATE_INPUT_CODE',
    UPDATE_OUTPUT_CODE: 'CODE_FORMATTER/UPDATE_OUTPUT_CODE',
    UPDATE_CODE_TYPE: 'CODE_FORMATTER/UPDATE_CODE_TYPE',
};

export default CONST;

